let item = document.querySelectorAll('.vg-catalog .vg-catalog-item');

function hoverEffect() {
	for(let el of item) {
		el.addEventListener('mouseover', function () {
			for(let elem of item) {
				elem.classList.remove('active')
			}
			this.classList.add('active')
		});

		el.addEventListener('mouseout', function () {
			for(let elem of item) {
				elem.classList.add('active')
			}
		})
	}
}

hoverEffect();

